import { useTranslator } from 'static/script/app/lang';
import React from 'react';

const OpenOnDeviceButton = ({ isAutoStartAllowed, autoStartToken }) => {
    const { t } = useTranslator();

    if (!isAutoStartAllowed) {
        return null;
    }

    const url = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
    return (
        <a className="btn btnprimary" href={url} role="button">
            {t('bankIdModal_OpenAppOnThisDevice')}
        </a>
    );
};

export default OpenOnDeviceButton;
